import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function CheckoutCancelPage() {
    return (
        <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-4">
            <div className="text-center max-w-md" data-testid="checkout-cancel">
                <div className="w-24 h-24 rounded-full bg-slate-100 flex items-center justify-center mx-auto mb-6">
                    <XCircle className="w-12 h-12 text-slate-400" />
                </div>
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    Payment Cancelled
                </h1>
                <p className="text-slate-600 mb-6">
                    No worries! Your cart is still saved. Ready when you are.
                </p>
                <Link to="/cart">
                    <Button className="btn-primary">
                        <ArrowLeft className="w-4 h-4 mr-2" />
                        Return to Cart
                    </Button>
                </Link>
            </div>
        </div>
    );
}
